import _map from 'lodash/map'

import Image from 'components/Image'
import Title from 'components/Title'
import Paragraph from 'components/Paragraph'

import Styled from './styled'

export default function SectionWhyUs({ data }) {
  const title = data?.title
  const contents = data?.contents

  return (
    <Styled>
      <Title level={2}>{title}</Title>

      <div className="why-us-content">
        {_map(contents, (item, index) => {
          const image = item?.image?.url
          const title = item?.title
          const detail = item?.description

          return (
            <div key={index} className="why-us-block">
              <Image src={image} className="image-why-us" width={64} height={64} />

              <div className="title-block">
                <Title level={3}>{title}</Title>
                <Paragraph className="detail">{detail}</Paragraph>
              </div>
            </div>
          )
        })}
      </div>
    </Styled>
  )
}
